import { createContext } from 'react';
import { createContextualCan } from '@casl/react';
import { PureAbility } from '@casl/ability';

export const AbilityContext = createContext({} as PureAbility);
export const Can = createContextualCan(AbilityContext.Consumer);